export type Theme = 'light' | 'dark';

export interface PriceItem {
  value: string;
  label: string;
}

export interface PricingPlan {
  id: string;
  theme: Theme;
  badge: string;
  // Для боковых карточек цена - это строка, для центральной - массив объектов
  price?: string; 
  pricesList?: PriceItem[];
  priceNote?: string;
  description: string;
  features: string[];
  buttonText: string;
}

export const pricingPlans: PricingPlan[] = [
  {
    id: 'single',
    theme: 'light',
    badge: 'Поштучная обработка',
    price: '500 ₽',
    description: 'Если нужно обновить одну фотографию в текущем объявлении',
    features: [
      'Обработка одной фотографии с вашими пожеланиями',
      'До 3-х вариантов обработки на ваш выбор (летняя, ночная, холодная и тд)',
      'Внесение до 3-х правок',
      'Оплата после получения результата'
    ],
    buttonText: 'Оставить заявку'
  },
  {
    id: 'full',
    theme: 'dark',
    badge: 'Пакет «Под ключ»',
    pricesList: [
      { value: '2 000 ₽', label: 'студия' },
      { value: '3 000 ₽', label: '1-комнатная квартира' },
      { value: '4 000 ₽', label: '2-комнатная квартира' },
      { value: '5 000 ₽', label: '3-комнатная квартира' },
    ],
    priceNote: 'за все фотографии, не важно какое количество',
    description: 'Для запуска нового объекта или полного обновления галереи. Вы присылаете все исходники, мы обрабатываем всё, чтобы объявление выглядело дорого и в едином стиле.',
    features: [
      'Обработка всех фотографий квартиры с вашими пожеланиями',
      'До 2-х вариантов обработки (летняя, ночная, холодная и тд)',
      'Внесение до 3-х правок',
      'Оплата после получения результата'
    ],
    buttonText: 'Оставить заявку'
  },
  {
    id: 'multi',
    theme: 'light',
    badge: 'Обработка от 3-х штук',
    price: '400 ₽ / шт',
    description: 'Если нужно обновить несколько фотографий в текущем объявлении',
    features: [
      'Обработка нескольких фотографий с вашими пожеланиями',
      'Внесение до 3-х правок',
      'Оплата после получения результата'
    ],
    buttonText: 'Оставить заявку'
  }
];